import { LOADING_STATUS } from './COMMON'

export function isLoaded<T>(data: T | LOADING_STATUS): data is T {
  return !Object.values(LOADING_STATUS).includes(data as any)
}
